import { InputAdornment, SvgIcon, TextField, type TextFieldProps } from "@mui/material";
import type React from "react";
import type { ChangeEvent } from "react";
import { Search as SearchIcon } from "react-feather";

import { useSearchInputStyles } from "./SearchInput.styles";

interface SearchInputProps {
    placeholder: string;
    handleChange?: (query: string) => void;
    textFieldProps?: TextFieldProps;
}

export const SearchInput: React.FC<SearchInputProps> = ({
    placeholder,
    handleChange,
    textFieldProps,
}) => {
    const classes = useSearchInputStyles();

    const handleQueryChange = (event: ChangeEvent<HTMLInputElement>): void => {
        event.stopPropagation();
        if (handleChange) {
            handleChange(event.target.value);
        }
    };

    return (
        <TextField
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                        </SvgIcon>
                    </InputAdornment>
                ),
            }}
            variant="standard"
            onChange={handleQueryChange}
            placeholder={placeholder}
            classes={{
                root: classes.root,
            }}
            {...textFieldProps}
        />
    );
};
